import Vue from 'vue'
import { S, G, M, A } from './types'
import { AppSettings } from '@/types/appSettings'
import { Getters, Mutations, Actions } from 'vuex'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  tabs: [],
  ble: {},
  bleConfig: {},
  isOnline: undefined,
  FCMToken: undefined,
  systemConfig: {}
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  tabs: ({ tabs }) => tabs,
  displayTabs: state =>
    state.tabs
      .filter(tab => tab.isActive)
      .sort((tab1, tab2) => tab1.order - tab2.order),
  ble: ({ ble }) => ble,
  bleConfig: ({ bleConfig }) => address =>
    !bleConfig || !bleConfig[address] ? null : bleConfig[address],
  isOnline: ({ isOnline }) => isOnline,
  systemConfig: ({ systemConfig }) => key =>
    !systemConfig ? undefined : systemConfig[key]
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  set: (state, appSettings) => {
    if (appSettings.tabs) {
      state.tabs = appSettings.tabs
    }
    if (appSettings.ble) {
      state.ble = appSettings.ble
    }
    if (appSettings.bleConfig) {
      state.bleConfig = appSettings.bleConfig
    }
    if (appSettings.isOnline !== undefined) {
      state.isOnline = appSettings.isOnline
    }
    if (appSettings.FCMToken) {
      state.FCMToken = appSettings.FCMToken
    }
    if (appSettings.systemConfig) {
      state.systemConfig = appSettings.systemConfig
    }
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async update({ commit, state }, newSettings) {
    const response = await Vue.$api.user.patchMe({
      params: { appSettings: JSON.stringify({ ...state, ...newSettings }) }
    })
    const appSettings = JSON.parse(response.appSettings) as AppSettings
    commit('set', appSettings)
  },

  async updateBleConfig({ commit, state }, newConfig) {
    const bleConfig = {
      ...state.bleConfig,
      ...newConfig
    }

    const response = await Vue.$api.user.patchMe({
      params: { appSettings: JSON.stringify({ ...state, bleConfig }) }
    })

    const appSettings = JSON.parse(response.appSettings) as AppSettings

    commit('set', appSettings)
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
